import { ThunkAction } from 'redux-thunk';
import { AxiosResponse } from 'axios';
import store from 'store';
import ApiClient, { createTokenConfig, isCancelled } from 'api/ApiClient';
import { NotificationsAction, showError } from '@spike/notifications-action';
import {
    MONTHLY_BREAKDOWN_REPORT_GET_START,
    MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS,
    MONTHLY_BREAKDOWN_REPORT_GET_ERROR,
    MonthlyBreakdownReportAction
} from './MonthlyBreakdownReportActionsTypes';
import type { MonthlyBreakdownReportDto } from './MonthlyBreakdownReportDto';
import { convertToMonthlyBreakdownReport } from './monthlyBreakdownReportConverter';

export const getMonthlyBreakdownReport = (
    year?: number
): ThunkAction<void, null, null, MonthlyBreakdownReportAction | NotificationsAction> => {
    return async dispatch => {
        dispatch(getStart());

        const { marketplaceId } = store.getState().login.auth;
        const timeZone = store.getState().login.auth.timeZone;

        let url = `/monthly_breakdown_report?marketplace_id=${marketplaceId}`;
        if (year) url += `&year=${year}`;

        try {
            const response: AxiosResponse<MonthlyBreakdownReportDto> = await ApiClient.get(
                url,
                createTokenConfig(store.getState().login.auth.token!)
            );

            dispatch(getSuccess(response.data, timeZone!));
        } catch (apiError) {
            if (!isCancelled(apiError)) {
                dispatch(getError());
                dispatch(showError('Too many records to display. Please try a shorter date range.'));
            }
        }
    };
};

const getStart = (): MonthlyBreakdownReportAction => ({
    type: MONTHLY_BREAKDOWN_REPORT_GET_START
});

const getSuccess = (dto: MonthlyBreakdownReportDto, timeZone: string): MonthlyBreakdownReportAction => ({
    type: MONTHLY_BREAKDOWN_REPORT_GET_SUCCESS,
    payload: {
        report: convertToMonthlyBreakdownReport(dto, timeZone)
    }
});

const getError = (): MonthlyBreakdownReportAction => ({
    type: MONTHLY_BREAKDOWN_REPORT_GET_ERROR
});
